import { Form, Row, Input, Select, Checkbox, Radio, DatePicker, Col, Switch, InputNumber, AutoComplete, TreeSelect, Typography, Button, Upload, Alert, Divider } from 'antd';
import { PropTypes } from 'prop-types';
import React from 'react';
import FhSimpleModal from './FhSimpleModal';
import 'moment/locale/zh-cn';
import ImgCrop from 'antd-img-crop';
import 'antd/es/modal/style';
import 'antd/es/slider/style';
import './FhAddModal.less';
const Option = Select.Option;
const FormItem = Form.Item;
const { RangePicker } = DatePicker;
const { TextArea } = Input;
const { Text } = Typography;
const dateFormatList = ['YYYY-MM-DD', 'YYYYMMDD', 'YYYY/MM/DD'];

/**
 *  添加或编辑弹框组件
 *  label：筛选项名称； field：筛选项唯一key值； initialValue：初始化值； placeholder：无数据时展示内容； width：筛选项宽度；
 *  format: 时间格式，默认['YYYY-MM-DD', 'YYYYMMDD', 'YYYY/MM/DD']三种格式; onChange：项目选择事件
 *  1.RANGEPICKER 时间区间  Momonet 数组
 *  2.INPUT 输入框   prefix 输入框前加内容  suffix输入框后加内容
 *  3.SELECT 下拉框  list： option项{key:,value:}
 *  4.CHECKBOX 选择框
 *  4.TEXTAREA 文本框
 */
class FhAddModal extends React.Component {
  formRef = React.createRef();
  initValueFlag = true; // 记录是否已进行初始赋值
  constructor(props) {
    super(props);
    this.state = {
      tip: {}
    };

    this.changeData = {};
    this.changeField = {};
  }

  onCreate = () => {
    this.formRef.current.submit();
  }

  onFinish = value => {
    //  下拉为undefined => null
    const param = {};
    Object.keys(value).forEach(key => {
      param[key] = value[key] === undefined ? null : value[key];
    });
    this.props.onCreate(param);
  }

  reset = () => {
    this.changeData = {};
    this.changeField = {};
    this.formRef && this.formRef.current && this.formRef.current.resetFields();
  }

  /**
   * 设置Form字段值。
   */
  setFormFieldsValue = (values) => {
    this.formRef.current && this.formRef.current.setFieldsValue(values);
    this.setChangeData(values);
  }

  setChangeData = async(values) => {
    for (const key in (values || {})) {
      this.changeData[key] = values[key];
    }
  }

  shouldComponentUpdate = (nextProps) => {
    // 重置初始值
    if (nextProps.visible && this.initValueFlag) {
      this.initValueFlag = false;
      this.formRef.current && this.formRef.current.setFieldsValue(nextProps.initialValues);
    }
    if (!nextProps.visible && this.formRef.current) {
      this.reset();
      this.initValueFlag = true;
    }
    return true;
  }

  initFormList = (formListOrg) => {
    const formList = formListOrg || this.props.formList;
    const formItemList = [];
    const span = 24 / ((this.props.span > 0 && this.props.span < 4) ? this.props.span : 2);
    if (formList && formList.length > 0) {
      formList.forEach((item, index) => {
        switch (item.type) {
          case 'REMARK':
            formItemList.push(<Col key={index} span={span}>{this.remarkItem(item)}</Col>);
            break;
          case 'INPUT':
            formItemList.push(<Col style={{ display: item.hidden ? 'none' : 'block' }} key={index} span={span}>{this.inputItem(item)}</Col>);
            break;
          case 'INPUTSPLIT':
            formItemList.push(<Col style={{ display: item.hidden ? 'none' : 'block' }} key={index} span={span}>{this.inputSplitItem(item)}</Col>);
            break;
          case 'TEXTAREA':
            formItemList.push(<Col style={{ display: item.hidden ? 'none' : 'block', paddingBottom: '20px' }} key={index} span={24} >{this.textAreaItem(item)}</Col>);
            break;
          case 'NUMBER':
            formItemList.push(<Col style={{ display: item.hidden ? 'none' : 'block' }} key={index} span={span}>{this.inputNumberItem(item)}</Col>);
            break;
          case 'PASSWORD':
            formItemList.push(<Col style={{ display: item.hidden ? 'none' : 'block' }} key={index} span={span}>{this.inputPasswordItem(item)}</Col>);
            break;
          case 'SELECT':
            formItemList.push(<Col style={{ display: item.hidden ? 'none' : 'block' }} key={index} span={span}>{this.selectItem(item)}</Col>);
            break;
          case 'TREESELECT':
            formItemList.push(<Col style={{ display: item.hidden ? 'none' : 'block' }} key={index} span={span}>{this.treeSelectItem(item)}</Col>);
            break;
          case 'AUTOCOMPLETE':
            formItemList.push(<Col style={{ display: item.hidden ? 'none' : 'block' }} key={index} span={span}>{this.autoCompleteItem(item)}</Col>);
            break;
          case 'CHECKBOX':
            formItemList.push(<Col style={{ display: item.hidden ? 'none' : 'block' }} key={index} span={span}>{this.checkboxItem(item)}</Col>);
            break;
          case 'CHECKBOXGROUP':
            formItemList.push(<Col style={{ display: item.hidden ? 'none' : 'block' }} key={index} span={item.span || span}>{this.checkboxGroupItem(item)}</Col>);
            break;
          case 'RADIO':
            formItemList.push(<Col style={{ display: item.hidden ? 'none' : 'block' }} key={index} span={item.span || span}>{this.radioItem(item)}</Col>);
            break;
          case 'SWITCH':
            formItemList.push(<Col style={{ display: item.hidden ? 'none' : 'block' }} key={index} span={span}>{this.switchItem(item)}</Col>);
            break;
          case 'DATE':
            formItemList.push(<Col style={{ display: item.hidden ? 'none' : 'block' }} key={index} span={span}>{this.dateItem(item)}</Col>);
            break;
          case 'RANGEPICKER':
            formItemList.push(<Col style={{ display: item.hidden ? 'none' : 'block' }} key={index} span={24}>{this.rangePickerItem(item)}</Col>);
            break;
          case 'TYPOGRAPHY':
            formItemList.push(<Col style={{ display: item.hidden ? 'none' : 'block' }} key={index} span={24}>{this.typographyItem(item)}</Col>);
            break;
          case 'CROPUPLOAD':
            formItemList.push(<Col style={{ display: item.hidden ? 'none' : 'block' }} key={index} span={span}>{this.cropUploadItem(item)}</Col>);
            break;
          case 'UPLOAD':
            formItemList.push(<Col style={{ display: item.hidden ? 'none' : 'block' }} key={index} span={item.span || span}>{this.uploadItem(item)}</Col>);
            break;
          case 'PLACEHOLDER':
            formItemList.push(<Col style={{ display: item.hidden ? 'none' : 'block', padding: 0, minHeight: 0 }} key={index} span={span}></Col>);
            break;
          case 'TEXT':
            formItemList.push(<Col style={{ display: item.hidden ? 'none' : 'block', paddingBottom: 5, paddingTop: 5, paddingLeft: item.pL, fontWeight: 500 }} key={index} span={24}>{item.text}</Col>);
            break;
          case 'SPLITLINE':
            formItemList.push(<Divider plain={item.plain} orientation={item.orientation}>{item.content}</Divider>);
            break;
          case 'SHOULDUPDATE':
            formItemList.push(<Col style={{ display: item.hidden ? 'none' : 'block' }} key={index} span={item.span || span}>{this.shouldUpdate(item)}</Col>);
            break;
          default:
        }
      });
    }
    return formItemList;
  }

  remarkItem = (item) => {
    return (
      <p style={{ textAlign: 'center', marginBottom: '0', color: 'red', fontSize: '12px' }}>{item.text}</p>
    );
  }

  // 输入框组件
  inputItem = (item) => {
    const disabledFlag = (this.props.addParameter && this.props.addParameter[item.field] && this.props.addParameter[item.field].disabled !== undefined) ? this.props.addParameter[item.field].disabled : item.disabled;
    return (<>
      <FormItem label={item.label} name={item.field} key={item.field} rules={disabledFlag ? [] : item.rules} validateTrigger={item.validateTrigger} hidden={item.hidden}>
        <Input className={item.className ? item.className : ''} autoFocus={item.autoFocus} prefix={item.before && item.before()} suffix={item.after && item.after()} type="text" placeholder={item.placeholder} allowClear={item.allowClear === undefined ? true : item.allowClear} title={item.title}
          defaultValue={item.defaultValue} onBlur={item.onBlur} onChange={item.onChange} onFocus={item.onFocus} onClick={item.onClick} onPressEnter={item.onPressEnter}
          disabled={disabledFlag} />
      </FormItem>
      {/* this.props.addShowTip动态变更提示信息 */}
      {(this.props.addShowTip && this.props.addShowTip[item.field]) ? <div key={item.field + 'Tip'} style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '5px' }}>
        <Alert
          message={(this.props.addShowTip && this.props.addShowTip[item.field])}
          type="warning"
          showIcon
          closable
          onClose={() => { this.onAlterClose(item.field + 'Tip'); }}
        />
      </div> : null}
    </>);
  }

  // 输入框分割组件, children 中字段disabled则不做校验, item中mainIndex可作为替换或添加 item中的字段(考虑兼容动态字段,待完善)
  inputSplitItem = (item) => {
    const initLayout = {
      labelCol: { xs: { span: 0 }, sm: { span: 0 } },
      wrapperCol: { xs: { span: 24 }, sm: { span: 24 } }
    };
    const { initialValues } = this.props;
    const mainIndex = (item.mainIndex !== undefined && item.mainIndex !== null);
    const len = (item.children && item.children.length) || 0;
    return (<>
      <FormItem label={item.label} hidden={item.hidden} componenttype="inputSplitItem">
        {((mainIndex && (item.mainIndex + 1 > len)) ? [...(item.children || []), { ...item, children: null }] : (item.children && item.children)).map((subItem, index) => {
          const splitStr = index === 0 ? null : item.splitStr || '-';
          if (mainIndex && index === +item.mainIndex) {
            const disabledFlag = (this.props.addParameter && this.props.addParameter[item.field] && this.props.addParameter[item.field].disabled !== undefined) ? this.props.addParameter[item.field].disabled : item.disabled;
            if (this.changeField[item.field]) {
              this.changeField[item.field].add(item.field);
            } else {
              this.changeField[item.field] = new Set([item.field]);
            }
            this.changeData[item.field] = initialValues[item.field] || '';
            return <>{splitStr}<FormItem {...initLayout} name={item.field} key={'split-' + item.field} rules={disabledFlag ? [] : item.rules} validateTrigger={item.validateTrigger} hidden={item.hidden}>
              <Input className={item.className ? item.className : ''} autoFocus={item.autoFocus} prefix={item.before && item.before()} suffix={item.after && item.after()} type="text" placeholder={item.placeholder} allowClear={item.allowClear === undefined ? true : item.allowClear} title={item.title}
                defaultValue={item.defaultValue} onBlur={item.onBlur} onChange={(event) => { this.changeData[item.field] = event.target.value; item.onChange && item.onChange(this.changeData[item.field], this.changeDataValue(item.field), item.field); }} onFocus={item.onFocus} onClick={item.onClick} onPressEnter={item.onPressEnter}
                disabled={disabledFlag} />
            </FormItem></>;
          } else {
            const disabledFlag = (this.props.addParameter && this.props.addParameter[subItem.field] && this.props.addParameter[subItem.field].disabled) ? this.props.addParameter[subItem.field].disabled : subItem.disabled;
            if (this.changeField[item.field]) {
              this.changeField[item.field].add(subItem.field);
            } else {
              this.changeField[item.field] = new Set([subItem.field]);
            }
            this.changeData[subItem.field] = initialValues[subItem.field] || '';
            return <>{splitStr}<FormItem {...initLayout} name={subItem.field} key={'split-' + subItem.field} rules={disabledFlag ? [] : subItem.rules} validateTrigger={subItem.validateTrigger}>
              <Input className={subItem.className ? subItem.className : ''} autoFocus={subItem.autoFocus} prefix={subItem.before && subItem.before()} suffix={subItem.after && subItem.after()} type="text" placeholder={subItem.placeholder} allowClear={subItem.allowClear === undefined ? true : subItem.allowClear} title={subItem.title}
                defaultValue={subItem.defaultValue} onBlur={subItem.onBlur} onChange={(event) => { this.changeData[subItem.field] = event.target.value; item.onChange && item.onChange(this.changeData[subItem.field], this.changeDataValue(item.field), subItem.field); }} onFocus={subItem.onFocus} onClick={subItem.onClick} onPressEnter={subItem.onPressEnter}
                disabled={disabledFlag} />
            </FormItem></>;
          }
        })}
      </FormItem>
      {/* this.props.addShowTip动态变更提示信息 */}
      {(this.props.addShowTip && this.props.addShowTip[item.field]) ? <div key={item.field + 'Tip'} style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '5px' }}>
        <Alert
          message={(this.props.addShowTip && this.props.addShowTip[item.field])}
          type="warning"
          showIcon
          closable
          onClose={() => { this.onAlterClose(item.field + 'Tip'); }}
        />
      </div> : null}
    </>);
  }

  changeDataValue = (field) => {
    const valueList = [];
    const fieldArr = this.changeField[field] ? [...this.changeField[field]] : [];
    for (const fieldName of fieldArr) {
      const value = this.changeData[fieldName] === undefined || this.changeData[fieldName] === null ? '' : this.changeData[fieldName];
      valueList.push(value);
    }
    return valueList;
  }

  // 数字输入框组件
  inputNumberItem = (item) => {
    const disabledFlag = (this.props.addParameter && this.props.addParameter[item.field] && this.props.addParameter[item.field].disabled !== undefined) ? this.props.addParameter[item.field].disabled : item.disabled;
    return (
      <FormItem label={item.label} name={item.field} key={item.field} rules={disabledFlag ? [] : item.rules}>
        <InputNumber placeholder={item.placeholder} formatter={(value, info) => { return item.formatter ? item.formatter(value, { ...info, disabledFlag }) : value; }} parser={item.parser} style={{ width: '100%' }} defaultValue={item.defaultValue}
          disabled={disabledFlag} />
      </FormItem>
    );
  }

  // 文本框组件
  textAreaItem = (item) => {
    const disabledFlag = (this.props.addParameter && this.props.addParameter[item.field] && this.props.addParameter[item.field].disabled !== undefined) ? this.props.addParameter[item.field].disabled : item.disabled;
    const { initialValues } = this.props;
    return (<div style={{ position: 'relative' }}>
      <FormItem label={item.label} key={item.field}
        required={item.required ? item.required : false} // 添加 required 属性
        labelCol={item.labelCol ? item.labelCol : { xs: { span: 10 }, sm: { span: 4 } }}
        wrapperCol={item.wrapperCol ? item.wrapperCol : { xs: { span: 12 }, sm: { span: 20 } }}>
        {item.formWrapperBefore && <div className='form-before'>
          {item.formWrapperBefore(initialValues)}
        </div>}
        <FormItem name={item.field} key={item.field + 'textarea'} rules={disabledFlag ? [] : item.rules}
          labelCol={item.labelCol ? item.labelCol : { xs: { span: 0 }, sm: { span: 0 } }}
          wrapperCol={item.wrapperCol ? item.wrapperCol : { xs: { span: 24 }, sm: { span: 24 } }}>
          <TextArea type="text" autoSize={item.autoSize || { minRows: 4, maxRows: 4 }} placeholder={item.placeholder} defaultValue={item.defaultValue}
            disabled={disabledFlag} showCount maxLength={item.maxLength || 500} onChange={item.onChange} />
        </FormItem>
      </FormItem>
      {item.displayExtr && <div style={{ minHeight: '22px' }}>
        <Row>
          <Col span={item.labelCol?.sm?.span || 4}></Col>
          <Col span={item.wrapperCol?.sm?.span || 20}>
            <div style={{ paddingRight: '50px' }}>
              {item.displayExtr}
            </div>
          </Col>
        </Row>
      </div>}
    </div>);
  }

  // 密码框组件
  inputPasswordItem = (item) => {
    return (
      <FormItem label={item.label} name={item.field} key={item.field} rules={item.rules} validateTrigger={item.validateTrigger} dependencies={item.dependencies}>
        <Input.Password placeholder={item.placeholder} autoFocus={item.autoFocus} onPressEnter={item.onPressEnter} />
      </FormItem>
    );
  }

  // 选择器组件
  selectItem = (item) => {
    const { span, formItemLayout } = this.props;
    const formItemLayoutInit = formItemLayout || {
      labelCol: {
        xs: { span: 10 },
        sm: { span: (4 * ((span > 0 && span < 4) ? span : 2)) }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: (24 - (4 * ((span > 0 && span < 4) ? span : 2))) }
      }
    };
    const disabledFlag = (this.props.addParameter && this.props.addParameter[item.field] && this.props.addParameter[item.field].disabled !== undefined) ? this.props.addParameter[item.field].disabled : item.disabled;
    // 将下拉框 相对于首屏中 modal的 form 定位,随之滚动
    const getSelectPopupContainer = () => {
      const ref = document.getElementById(this.props.modalFormName);
      // 需要对滚动form添加定位
      if (ref) {
        ref.style.position = 'relative';
        return ref;
      } else {
        console.error('warning: 首屏未获取到' + this.props.modalFormName + '元素节点');
        return document.body;
      }
    };
    // 默认 挂载到 body
    const getPopupContainer = this.props.modalFormName ? getSelectPopupContainer : () => document.body;
    const selectNode = <FormItem label={item.label} name={item.field} key={item.field} rules={disabledFlag ? [] : item.rules} {...formItemLayoutInit} hidden={item.hidden}>
      <Select
        allowClear={item.allowClear !== false}
        style={item.width ? { width: item.width } : { width: 160 }}
        placeholder={item.placeholder}
        showSearch={item.showSearch !== undefined ? item.showSearch : true}
        showArrow={item.showArrow}
        maxTagCount={item.maxTagCount}
        optionFilterProp="children"
        onChange={(value, option) => { item.onChange && item.onChange(value, option); this.setState({ tip: Object.assign({}, this.state.tip, { [item.field + 'Tip']: true }) }); }}
        onFocus={item.onFocus}
        onBlur={item.onBlur}
        onSearch={item.onSearch}
        filterOption={item.filterOption}
        getPopupContainer={getPopupContainer}
        mode={item.mode}
        defaultValue={item.initialValue}
        dropdownMatchSelectWidth={item.dropdownMatchSelectWidth === undefined ? false : item.dropdownMatchSelectWidth}
        disabled={disabledFlag}
      >
        {this.getOptionList((this.props.itemList && this.props.itemList[item.field]) ? this.props.itemList[item.field] : item.list, null, item.handleOption, item)}
      </Select>
    </FormItem>;
    return (<>
      {item.suffix
        ? <FormItem componenttype="suffixSelect" wrapperCol={{
          xs: { span: 24 },
          sm: { span: 24 }
        }}>
          {selectNode}
          {item.suffix && item.suffix.render()}
        </FormItem>
        : selectNode}
      {/* item.showTip只有onChange才会触发提示信息 */}
      {(this.props.addParameter && this.props.addParameter[item.field] && this.props.addParameter[item.field].disableTip) ? null : (item.showTip && this.state.tip[item.field + 'Tip']) && <div key={item.field + 'Tip'} style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '5px' }}>
        <Alert
          message={item.showTip}
          type="warning"
          showIcon
          closable
          onClose={() => { this.onAlterClose(item.field + 'Tip'); }}
        />
      </div>}
      {/* this.props.addShowTip动态变更提示信息 */}
      {(this.props.addShowTip && this.props.addShowTip[item.field]) ? <div key={item.field + 'Tip'} style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '5px' }}>
        <Alert
          message={(this.props.addShowTip && this.props.addShowTip[item.field])}
          type="warning"
          showIcon
          closable
          onClose={() => { this.onAlterClose(item.field + 'Tip'); }}
        />
      </div> : null}
    </>);
  }

  getOptionList = (data, keyFiled, handleOption, selectItem) => {
    const initialValues = this.props.initialValues || {};
    if (!data) {
      return [];
    }
    if (handleOption && typeof handleOption !== 'function') {
      throw new Error('handleOption must be a function');
    }
    const keyStr = keyFiled || 'key';
    const valueStr = data.findIndex(item => {
      const key = item[keyStr];
      const keyNew = isNaN(+key) ? key : +key;
      return keyNew === initialValues[selectItem.field];
    });

    if (valueStr <= -1 && selectItem.initialName && initialValues[selectItem.field]) {
      data.push({
        addOptionFlag: 1,
        key: initialValues[selectItem.field],
        value: initialValues[selectItem.initialName]
      });
    }

    return data.map((item1) => {
      const item = { ...item1 };
      const key = item[keyStr];
      const keyNew = isNaN(+key) ? key : +key;
      item.key = keyNew;
      return (<Option allspelles={item.allSpelles ? item.allSpelles : ''} value={item.key} key={item.key} disabled={item.disabled || (handleOption && handleOption(item))} className={item.customClass === 'yes' ? 'customClass' : (item.disabled ? 'disabledClass' : '')} extra={item}>{item.value}</Option>);
    });
  }

  // 树选择器组件
  treeSelectItem = (item) => {
    const itemList = (this.props.itemList && this.props.itemList[item.field]) ? this.props.itemList[item.field] : item.list;
    const disabledFlag = (this.props.addParameter && this.props.addParameter[item.field] && this.props.addParameter[item.field].disabled !== undefined) ? this.props.addParameter[item.field].disabled : item.disabled;
    // 将下拉框 相对于首屏中 modal的 form 定位,随之滚动
    const getSelectPopupContainer = () => {
      const ref = document.getElementById(this.props.modalFormName);
      // 需要对滚动form添加定位
      if (ref) {
        ref.style.position = 'relative';
        return ref;
      } else {
        console.error('warning: 首屏未获取到' + this.props.modalFormName + '元素节点');
        return document.body;
      }
    };
    // 默认 挂载到 body
    const getPopupContainer = this.props.modalFormName ? getSelectPopupContainer : () => document.body;
    return (
      <FormItem label={item.label} name={item.field} key={item.field} rules={disabledFlag ? [] : item.rules}>
        <TreeSelect
          id={item.field}
          treeData={itemList}
          placeholder={item.placeholder}
          treeCheckable={item.treeCheckable}
          showCheckedStrategy={item.strategy}
          allowClear={true}
          showSearch={item.showSearch !== undefined ? item.showSearch : true}
          treeDefaultExpandAll={item.expandAll}
          value={item.initialValue}
          treeNodeFilterProp={item.treeNodeFilterProp || 'title'}
          filterTreeNode={item.filterTreeNode}
          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
          onChange={item.onChange}
          getPopupContainer={getPopupContainer}
          onSearch={item.onSearch}
          dropdownMatchSelectWidth={false}
          disabled={disabledFlag}
        />
      </FormItem>
    );
  }

  // 自动完成组件
  autoCompleteItem = (item) => {
    const itemList = (this.props.itemList && this.props.itemList[item.field]) ? this.props.itemList[item.field] : item.list || [];
    const itemListNew = itemList.map(item => {
      const key = item.key;
      const newItem = { ...item };
      if (!isNaN(+key)) {
        newItem.key = +key;
      }
      return newItem;
    }
    );
    const disabledFlag = (this.props.addParameter && this.props.addParameter[item.field] && this.props.addParameter[item.field].disabled !== undefined) ? this.props.addParameter[item.field].disabled : item.disabled;
    return (
      <FormItem label={item.label} name={item.field} key={item.field} rules={disabledFlag ? [] : item.rules}>
        <AutoComplete
          id={item.field}
          allowClear={true}
          options={itemListNew}
          style={item.width && { width: item.width }}
          onSearch={item.onSearch}
          onChange={item.onChange}
          onSelect={item.onSelect}
          disabled={disabledFlag}
          filterOption={item.filterOption}
          dropdownMatchSelectWidth={item.dropdownMatchSelectWidth === undefined ? false : item.dropdownMatchSelectWidth}
        />
      </FormItem>
    );
  }

  // 复选框组组件
  checkboxGroupItem = (item) => {
    const itemList = (this.props.itemList && this.props.itemList[item.field]) ? this.props.itemList[item.field] : item.optionList;
    const fieldAddParameter = this.props.addParameter && this.props.addParameter[item.field];
    return (<FormItem label={item.label} name={item.field} key={item.field} rules={item.rules} colon={item.colon}
      labelCol={item.labelCol ? item.labelCol : { xs: { span: 10 }, sm: { span: 4 } }}
      wrapperCol={item.wrapperCol ? item.wrapperCol : { xs: { span: 12 }, sm: { span: 20 } }}>
      <Checkbox.Group onChange={item.onChange} style={{ width: item.groupWidth || '100%' }}>
        <Row>
          {(itemList || []).map(option => {
            return (
              <Col key={option.key + 'col'} span={option.span || 8}>
                <Checkbox id={option.key} key={option.key} value={option.key} defaultChecked={option.defaultChecked}
                  disabled={fieldAddParameter && fieldAddParameter[option.key] && fieldAddParameter[option.key].disabled !== undefined ? fieldAddParameter[option.key].disabled : option.disabled}>
                  {option.value}
                </Checkbox>
              </Col>
            );
          })}
        </Row>
      </Checkbox.Group>
    </FormItem>);
  }

  // 复选框组件
  checkboxItem = (item) => {
    const disabledFlag = (this.props.addParameter && this.props.addParameter[item.field] && this.props.addParameter[item.field].disabled !== undefined) ? this.props.addParameter[item.field].disabled : item.disabled;
    return (
      <FormItem label={item.label} name={item.field} key={item.field} valuePropName="checked" rules={disabledFlag ? [] : item.rules}>
        <Checkbox id={item.field} onChange={item.onChange} defaultChecked={item.defaultChecked} disabled={disabledFlag} >
          {item.content}
        </Checkbox>
      </FormItem>
    );
  }

  // 单选框组件
  radioItem = (item) => {
    return (
      <FormItem label={item.label} name={item.field} key={item.field} rules={item.rules}
        labelCol={item.labelCol ? item.labelCol : { xs: { span: 10 }, sm: { span: 8 } }}
        wrapperCol={item.wrapperCol ? item.wrapperCol : { xs: { span: 12 }, sm: { span: 16 } }}>
        <Radio.Group options={(this.props.itemList && this.props.itemList[item.field]) ? this.props.itemList[item.field] : item.list}>
          {/* <Radio value={item.checkValue}/> */}
        </Radio.Group>
      </FormItem>
    );
  }

  // 选择器组件
  switchItem = (item) => {
    const disabledFlag = (this.props.addParameter && this.props.addParameter[item.field] && this.props.addParameter[item.field].disabled !== undefined) ? this.props.addParameter[item.field].disabled : item.disabled;
    return (
      <FormItem label={item.label} name={item.field} key={item.field} rules={disabledFlag ? [] : item.rules} valuePropName='checked'>
        <Switch onChange={item.onChange} disabled={disabledFlag} />
      </FormItem>
    );
  }

  // 日期组件
  dateItem = (item) => {
    const formItemLayoutSuffix = item.Layout || {
      labelCol: {
        xs: { span: 10 },
        sm: { span: 10 }
      },
      wrapperCol: {
        xs: { span: 14 },
        sm: { span: 14 }
      }
    };
    const disabledFlag = (this.props.addParameter && this.props.addParameter[item.field] && this.props.addParameter[item.field].disabled !== undefined) ? this.props.addParameter[item.field].disabled : item.disabled;
    return (item.suffix
      ? <div style={{ display: 'flex' }}>
        <div style={{ flex: 1 }}>
          <FormItem label={item.label} key={item.field} name={item.field} rules={disabledFlag ? [] : item.rules} {...formItemLayoutSuffix}>
            <DatePicker picker={item.picker ? item.picker : 'date'} disabledDate={item.disabledDate} disabled={disabledFlag}
              showToday={item.showToday || item.showToday === undefined }
              placeholder={item.placeholder} showTime={item.showTime} defaultValue={item.defaultValue} renderExtraFooter={item.renderExtraFooter}
              format={item.format == null ? dateFormatList : item.format} onChange={item.onChange} />
          </FormItem>
        </div>
        <div style={{ display: 'inline-flex', alignItems: 'center', marginBottom: '24px' }}>{item.suffix}</div>
      </div>
      : <FormItem label={item.label} key={item.field} name={item.field} rules={disabledFlag ? [] : item.rules} {...formItemLayoutSuffix}>
        <DatePicker picker={item.picker ? item.picker : 'date'} disabledDate={item.disabledDate} disabled={disabledFlag}
          showToday={item.showToday || item.showToday === undefined }
          placeholder={item.placeholder} showTime={item.showTime} defaultValue={item.defaultValue} renderExtraFooter={item.renderExtraFooter}
          format={item.format == null ? dateFormatList : item.format} onChange={item.onChange} style={{ width: '75%' }}/>
      </FormItem>
    );
  }

  // 日期范围选择组件
  rangePickerItem = (item) => {
    const format = item.format ? item.format : dateFormatList;
    const disabledFlag = (this.props.addParameter && this.props.addParameter[item.field] && this.props.addParameter[item.field].disabled !== undefined) ? this.props.addParameter[item.field].disabled : item.disabled;
    return (
      <FormItem label={item.label} key={item.field} name={item.field} rules={disabledFlag ? [] : item.rules} labelCol={{ xs: { span: 10 }, sm: { span: 4 } }} wrapperCol={{ xs: { span: 12 }, sm: { span: 20 } }}>
        <RangePicker placeholder={item.placeholder} format={format} onChange={item.onChange} defaultValue={item.defaultValue} disabled={disabledFlag} allowEmpty={item.allowEmpty || [false, false]} />
      </FormItem>
    );
  }

  // 排版组件
  typographyItem = (item) => {
    return (
      <FormItem key={item.field} name={item.field} wrapperCol={{ span: 24 }}>
        <Text type={item.textType}>{item.content}</Text>
      </FormItem>
    );
  }

  // 裁剪上传组件
  cropUploadItem = (item) => {
    return (
      <FormItem label={item.label} key={item.field} name={item.field} rules={item.rules}>
        <ImgCrop modalTitle={'裁切并上传图片'} rotate={true}>
          <Upload key="selectFile" accept=".png, .jpg, .jpeg" showUploadList={false} beforeUpload={item.onSelectFile} maxCount={item.maxCount}>
            <Button type="link" key="uploadAuthorizationImage">上传图片</Button>
          </Upload>
        </ImgCrop>
      </FormItem>
    );
  }

  // 上传组件
  uploadItem = (item) => {
    // pathList 表单只有单图片, images: 图片集合对象
    const { span, formItemLayout, images, pathList } = this.props;
    const formItemLayout1 = (item.layout || formItemLayout) || {
      labelCol: {
        xs: { span: 10 },
        sm: { span: (4 * ((span > 0 && span < 4) ? span : 2)) }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: (24 - (4 * ((span > 0 && span < 4) ? span : 2))) }
      }
    };
    const fileList = (images && images[item.field]) ? images[item.field] : (pathList || []);
    return (
      <FormItem {...formItemLayout1} label={item.label} key={item.field} name={item.field} rules={item.rules}>
        <Upload fileList={fileList} listType={item.listType || 'text'}
          onRemove={item.onRemove} key="selectFile" multiple={item.multiple} accept={item.accept === null ? '.png, .jpg, .jpeg' : item.accept} showUploadList={item.listShow} onChange={item.onChange} beforeUpload={(...args)=>{
            if(item.onSelectFile){
              item.onSelectFile(...args);
            }
            return false
          }} maxCount={item.maxCount}>
          {/* (!item.maxhidden || (!item.maxCount || !this.props.pathList || this.props.pathList.length < item.maxCount)) */}
          {!(item.maxhidden && (item.maxCount && fileList && fileList.length >= item.maxCount)) && <Button type="link" key="uploadAuthorizationImage1"
            disabled={(this.props.addParameter && this.props.addParameter[item.field] && this.props.addParameter[item.field].disabled) ? this.props.addParameter[item.field].disabled : item.disabled}
          >{item.uploadText || '上传图片'}</Button>}
        </Upload>
      </FormItem>
    );
  }

  // 动态组件
  shouldUpdate = (item) => {
    return (
      <FormItem label={item.label} shouldUpdate noStyle={item.noStyle} className={item.className || ''}
        labelCol={item.labelCol ? item.labelCol : { xs: { span: 10 }, sm: { span: 8 } }}
        wrapperCol={item.wrapperCol ? item.wrapperCol : { xs: { span: 12 }, sm: { span: 16 } }}>
        {item.child}
      </FormItem>
    );
  }

  // 选择框提示关闭
  onAlterClose = (field) => {
    this.setState({
      tip: Object.assign(this.state.tip, { [field]: false })
    });
  }

  render() {
    const { initialValues, onValuesChange, span, formItemLayout, onCancel, formList } = this.props;
    const formItemLayoutInit = formItemLayout || {
      labelCol: {
        xs: { span: 10 },
        sm: { span: (4 * ((span > 0 && span < 4) ? span : 2)) }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: (24 - (4 * ((span > 0 && span < 4) ? span : 2))) }
      }
    };
    return (
      <FhSimpleModal
        {...this.props}
        onCancel={() => { onCancel && onCancel(); this.setState({ tip: {} }); }}
        onCreate={this.onCreate}
      >
        <Form
          {...formItemLayoutInit}
          layout="horizontal"
          ref={this.formRef}
          onFinish={this.onFinish}
          initialValues={initialValues}
          onValuesChange={onValuesChange}
          name={this.props.modalFormName}
        >
          <Row gutter={[16, 8]}>
            {this.initFormList(formList)}
          </Row>
          {this.props.children && <div className='addModalChildren'>
            {this.props.children}
          </div>}
          {this.props.warningMessage && <div><br /><span style={{ color: 'red', marginLeft: '10px' }}>
            {this.props.warningMessage}
          </span></div>}
        </Form>
      </FhSimpleModal>
    );
  }
}
export default FhAddModal;

// 属性值类型
FhAddModal.propTypes = {
  form: PropTypes.object,
  addShowTip: PropTypes.object, // 提示信息(可动态更新)
  formList: PropTypes.array.isRequired,
  visible: PropTypes.bool, // 弹框是否展示
  onCancel: PropTypes.func, // 取消按钮
  onCreate: PropTypes.func.isRequired, // 保存按钮方法
  formItemLayout: PropTypes.object, // 排列格式
  initialValues: PropTypes.object, // 默认初始值
  addParameter: PropTypes.object, // 各项组件参数值{ disable: 禁用;  notShowTip: 改变时不展示Tip信息 (目前仅在 Select 可用) }
  pathList: PropTypes.array, // 上传文件名,item,listShow为true
  images: PropTypes.object,
  itemList: PropTypes.object,
  onValuesChange: PropTypes.func,
  children: PropTypes.element,
  warningMessage: PropTypes.element,
  span: PropTypes.number,
  forbiddenSetValueFlag: PropTypes.bool,
  modalFormName: PropTypes.string // 作为form的id使用, 可使下拉框跟随滚动
};
